<template>
  <main class="souscri">
    <div class="container">
      <div v-if="!loading">
        <div class="jumbotron">
          <div  v-if="bonds.id">
            <div class="mx-auto">
              <h5 class="gothic text-center">Appel pour bon</h5>
              <h1 class="display-1 d-inline style_ross_2 text-center text-dark gothicb">{{bonds.amount.toFixed(2).replace('.', ',') |currency}}</h1>
              <h5 class="gothic">Déja s’ouscrire : <span class="text-dark gothicb">{{total}}%</span></h5>
            </div>
            <div class="text-center my-3">
              <div class="mx-auto mb-3">
                <div class="d-inline-block p-3">
                  <h6 class="gothic">Compte à rebout</h6>
                  <div class="d-flex justify-content-center">
                    <div class="mx-1">
                      <h1 class="gothic my-0 display-4">9</h1>
                      <small class="text-center">Jour</small>
                    </div>
                    <div class="mx-1">
                      <h1 class="gothic my-0 display-4 text-dark-50">:</h1>
                    </div>
                    <div class="mx-1">
                      <h1 class="gothic my-0 display-4">13</h1>
                      <small class="text-center">Heurs</small>
                    </div>
                    <div class="mx-1">
                      <h1 class="gothic my-0 display-4 text-dark-50">:</h1>
                    </div>
                    <div class="mx-1">
                      <h1 class="gothic my-0 display-4">15</h1>
                      <small class="text-center">Mins</small>
                    </div>
                    <div class="mx-1">
                      <h1 class="gothic my-0 display-4 text-dark-50">:</h1>
                    </div>
                    <div class="mx-1">
                      <h1 class="gothic my-0 display-4">22</h1>
                      <small class="text-center">Secs</small>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-warning btn-lg mx-3"  @click="onModal('bouscri')"><i class="fa fa-share mr-2"></i> Souscrire</button>
            </div>
          </div>
          <div v-if="!bonds.id"><h5 class="gothic text-center">Aucun bond encours !!!</h5></div>
        </div>
        <souscriList :objects="souscris" @show="onShow" v-if="souscris.length"/>
        <souscri-form v-model="souscri" @submit="onAdd" @toggle="onModal"/>
      </div>
      <loader v-else/>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

let souscriForm = {
  props: {
    value: Object
  },
  data() {
    return {modal: 'bouscri'}
  },
  template: `
  <modal v-model="modal" @close="$emit('toggle', modal)">
    <h5 slot="header">Souscrire au bond</h5>
    <form @submit.prevent="$emit('submit', value)">
      <div class="form-group">
        <label class="">Montant</label>
        <input type="text" class="form-control" v-model="value.amount">
      </div>
      <div class="form-group">
        <label class="">Taux</label>
        <input type="text" class="form-control" disabled="disabled" value="1%">
      </div>
      <div class="form-group">
        <label class="">Total</label>
        <input type="text" class="form-control" disabled="disabled" :value="0.99*value.amount">
      </div>
      <div class="form-group">
        <label class="">Code</label>
        <input type="password" class="form-control" v-model="value.code" autocomplete>
      </div>
      <div class="form-group">
        <button type="submit" class="btn btn-outline-warning btn-lg btn-block">Subscribe</button>
      </div>
    </form>
  </modal>
  `
};

let souscriList = {
  props: {
    objects: Array
  },
  template: `
  <table class="table table-hover">
    <thead class="thead-dark">
      <tr>
        <th scope="col"><i class="fa fa-calendar"></i> Date</th>
        <th scope="col"><i class="fa fa-shopping-cart"></i> Montant</th>
        <th scope="col"><i class="fa fa-tag"></i> Type</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="obj in objects" :key="obj.id" @click.prevent="$emit('show', obj)">
        <th scope="row">{{obj.updatedAt}}</th>
        <td>{{obj.amount}}</td>
        <td>{{obj.type}}</td>
      </tr>
    </tbody>
  </table>
  `
};

export default {
  name: 'souscri',
  data() {
    return { loading: true, souscri: {}}
  },
  computed: {
    ...mapGetters('resource', {bonds: 'BOND', souscris: 'BONDS'}),
    user() { return this.$store.getters.loggedAs; },
    total() { return 100*Math.round(this.bonds.current/this.bonds.amount) }
  },
  methods: {
    ...mapActions('resource', ['insertBond','fetchBond','removeBond']),
    onAdd(value){
      value.to = {id: this.bonds.id}; this.loading = true;
      this.removeBond(value).then(() => this.souscri = {}).catch(() => this.onModal('bouscri')).finally(() => {this.onModal('bouscri');this.loading = false;});
    },
    onShow(value){
      this.souscri = { ...value }
      this.onModal('bouscri')
    },
    onModal(value) {$(`#${value}`).modal('toggle')}
  },
  created() { 
    this.fetchBond().then(() => {
      if(this.bonds.id) 
        this.insertBond(this.bonds.id).then(() => this.loading = false);
      else this.loading = false
    }); 
  },
  components: {souscriForm, souscriList}
}
</script>

<style scoped lang="scss"></style>
